




















import { Vue, Component, Watch } from "vue-property-decorator";
// @ts-ignore
import PlaidLink from "vue-plaid-link";
import AccountsTable from "./AccountsTable.vue";
import { bankStore } from "@/bank/store";
import { profileStore } from "@/account/store";

@Component({
  components: {
    PlaidLink,
    AccountsTable
  }
})
export default class BankInfo extends Vue {
  showCard = false;
  isPlaidLinkExist: boolean | null = null;
  accounts = [];
  loading = false;
  async beforeMount() {
    const user = profileStore.state.profile!.user;
    this.loading = true
    this.isPlaidLinkExist = await bankStore.isPlaidLinkExist(user);
    this.loading = false

  }

  onLoad() {}

  async onSuccess(public_token: any, metadata: any) {
    await bankStore.loadPlaidAccessToken(metadata.public_token);
    this.isPlaidLinkExist = true;
  }

  onExit(err: any, metadata: any) {}

  onEvent(eventName: any, metadata: any) {}

  @Watch("isPlaidLinkExist")
  async onPlaidExistChanged(val: boolean, oldVal: boolean) {
    if (val === true) {
      this.loading = true;
      try {
        this.accounts = await bankStore.loadPlaidAccountsBalances();
        console.log("accounts", this.accounts);
      } catch (error) {
        console.log("this user has no account.");
      }
      this.loading = false;
    }
  }
}
